import clsx from 'clsx';

export default function Card({ children, className = '', ...props }) {
  return (
    <div
      className={clsx(
        'bg-white rounded-card shadow-sm border border-gray-100',
        'transition-all duration-300',
        'hover:shadow-lg hover:-translate-y-0.5',
        'p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
